








































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "@/lib/ajax";
import AMap from './amaps.vue';
import Echarts from './aecharts.vue';
import Weather from './weathers.vue';
@Component({
  components: { AMap, Echarts, Weather},
}) 
export default class home extends AbpBase {
  list = [];
  handlelist = [];
  tz(e){
    if(e==1)
    this.$router.push("/equip/thequipment");
    if(e==2)
    this.$router.push("/equip/thequipment");
    if(e==3)
    this.$router.push("/equip/equipment");
    if(e==4)
    this.$router.push("/equip/inairequipment");
    if(e==5)
    this.$router.push("/equip/gasequipment");
    if(e==6)
    this.$router.push("/equip/outairequipment");
    if(e==7)
    this.$router.push("/equip/moiequipment");
  }
 async getCount(){
    this.list=await this.$store.dispatch({
      type: "thequipment/getAllEquCount",
    });
    this.handlelist=await this.$store.dispatch({
      type: "thhandlewarning/getAllwarning",
    });
  }
  created() {
   this.getCount();
  }
}
